// World 3 (Tide) — generated. Four colours, bigger boards, deeper chains.
// See docs/difficulty.md §5 world 3 profile.
import type { LevelDef } from '@tessera/engine';
import { WORLD_3_GENERATED } from './world3-generated';

export const WORLD_3_LEVELS: LevelDef[] = [...WORLD_3_GENERATED];
